import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {deleteBookingsByToken} from '@/api/repositories/BookingDeletionRepository';

export async function handleBookingDeletion(
    to: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const token = to.params.token;

    if (typeof token !== 'string') {
        return {name: 'Login'};
    }

    try {
        const {bookingCount} = await deleteBookingsByToken(token);

        return {name: 'BookingDeletionConfirmation', query: {count: bookingCount}};
    } catch {
        return {name: 'Login'};
    }
}
